import Button from 'components/Button'
import { Plus } from 'components/Icons'
import Modal from 'components/Modal'
import Stars from 'components/Stars'
import { AddReview } from 'components/Widgets/Landing'
import calculatePercent from 'helpers/calculatePercent'
import React, { useState } from 'react'
import useProduct from 'store/SingleProductProvider'
import { AddReviewContainer } from 'style/Landing.style'
import {
  ReviewsContainer,
  ReviewsContent,
  ReviewsItem,
  ReviewsItems,
  ReviewsSummery,
  ReviewsSummeryStar,
  ReviewsSummeryStars,
  ReviewsTitle,
} from './Reviews.style'

const Reviews = props => {
  const [reviewModalShow, setReviewModalShow] = useState(false)
  const {
    product: { reviews: prReview },
  } = useProduct()

  if (!prReview) return null

  const { meta, reviews } = prReview

  return (
    <ReviewsContainer>
      <ReviewsTitle>
        <h2 id="product-reviews">
          {meta.data.count ? 'შეფასებები' : 'შეფასება არ არის'}
        </h2>
        <Button
          style={{
            color: 'black',
            backgroundColor: '#ededed',
            backgroundImage: 'none',
          }}
          color="orange"
          onClick={() => setReviewModalShow(true)}
        >
          <Plus color={'black'} />
          შეაფასე
        </Button>
      </ReviewsTitle>

      <Modal title="დატოვე შეფასება" show={reviewModalShow}>
        <AddReviewContainer>
          <AddReview />
        </AddReviewContainer>
      </Modal>

      {meta.data.count ? (
        <ReviewsContent>
          <ReviewsSummery>
            <h3>სულ: {meta.data.count} შეფასება</h3>
            <ReviewsSummeryStars>
              <ReviewsSummeryStar
                width={calculatePercent(
                  meta?.grouped?.[5] || 0,
                  meta.data.count
                )}
              >
                <Stars amount="5" />
                <div className="rating-bar" />
                <span>{meta?.grouped?.[5] || 0}</span>
              </ReviewsSummeryStar>
              <ReviewsSummeryStar
                width={calculatePercent(
                  meta?.grouped?.[4] || 0,
                  meta.data.count
                )}
              >
                <Stars amount="4" />
                <div className="rating-bar" />
                <span>{meta?.grouped?.[4] || 0}</span>
              </ReviewsSummeryStar>
              <ReviewsSummeryStar
                width={calculatePercent(
                  meta?.grouped?.[3] || 0,
                  meta.data.count
                )}
              >
                <Stars amount="3" />
                <div className="rating-bar" />
                <span>{meta?.grouped?.[3] || 0}</span>
              </ReviewsSummeryStar>
              <ReviewsSummeryStar
                width={calculatePercent(
                  meta?.grouped?.[2] || 0,
                  meta.data.count
                )}
              >
                <Stars amount="2" />
                <div className="rating-bar" />
                <span>{meta?.grouped?.[2] || 0}</span>
              </ReviewsSummeryStar>
              <ReviewsSummeryStar
                width={calculatePercent(
                  meta?.grouped?.[1] || 0,
                  meta.data.count
                )}
              >
                <Stars amount="1" />
                <div className="rating-bar" />
                <span>{meta?.grouped?.[1] || 0}</span>
              </ReviewsSummeryStar>
            </ReviewsSummeryStars>
          </ReviewsSummery>
          <ReviewsItems>
            {reviews.map(review => (
              <ReviewsItem
                itemProp="review"
                itemScope
                itemtype="https://schema.org/Review"
                key={review.id}
              >
                <h4>
                  <span itemProp="name">{review.user_name}</span> -{' '}
                  <span itemProp="datePublished">{review.date}</span>
                </h4>
                <div itemScope itemtype="https://schema.org/Rating">
                  <span className="hidden" itemProp="ratingValue">
                    {review.rating}
                  </span>
                  <span className="hidden" itemProp="bestRating">
                    5
                  </span>
                  <Stars amount={review.rating} />
                  <p itemProp="reviewBody">{review.message}</p>
                  {review.image ? (
                    <img
                      className="review-image"
                      src={review.image}
                      alt={review.user_name}
                    />
                  ) : null}
                </div>
              </ReviewsItem>
            ))}
          </ReviewsItems>
        </ReviewsContent>
      ) : null}
    </ReviewsContainer>
  )
}

export default Reviews
